<template>
  <div @contextmenu.prevent>
    <a class="dummy-center-logo" href="#" @click="toggleQuickMenu($event)">&nbsp;</a>
    <div class="dummy-center-logo">&nbsp;</div>
    <v-card tile class="menu-bar">
      <div class="mr-auto d-flex">
        <div>
          <v-row><page-title /></v-row>
        </div>
        <div><GroupSelector /></div>
      </div>
      <div v-if="primeMenuList.length > 0" class="quick-menu" :class="{ 'menu-selected': showMenu }">
        <div class="quick-menu-dummy" @click="toggleQuickMenu($event)"></div>
        <div class="quick-menu-wraper overflow-y-auto" @click="toggleQuickMenu($event)">
          <dl v-for="(menu, index) in primeMenuList" :key="index" class="quick-menu-sub">
            <dt>
              <v-icon>{{ menu.icon }}</v-icon>
              <span v-html="$t(menu.messageCode)" />
            </dt>
            <dd>
              <dl v-for="(child, index) in menu.children" :key="index" class="quick-menu-child">
                <dt>
                  <v-icon>{{ child.icon }}</v-icon>
                  <span v-html="$t(child.messageCode)" />
                </dt>
                <dd>
                  <ul class="quick-menu-grand">
                    <li v-for="(grand, index) in child.children" :key="index" @contextmenu="onContextMenu($event, grand)">
                      <a :href="'#' + grand.url" @click="changeMenu(grand)">
                        <v-icon small>{{ grand.icon }}</v-icon>
                        <span v-html="$t(grand.messageCode)" />
                        <!-- Added.by.KWSHin.2025.12.11.현재 선택된 화면의 메뉴의 우측에 "<<" 표시를 해준다. -->
                        <v-icon v-show="currentPath.startsWith(grand.url)" small>mdi-chevron-double-left</v-icon>
                      </a>
                    </li>
                  </ul>
                </dd>
              </dl>
            </dd>
          </dl>
        </div>
        <v-menu v-model="ctxtMenu.show" :position-x="ctxtMenu.x" :position-y="ctxtMenu.y" z-index="200" absolute offset-y>
          <div class="border-wrap">
            <v-list dense>
              <v-list-item @click="registerHome" link :disabled="false">
                <v-list-item-title>{{ ctxtMenu.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </div>
        </v-menu>
      </div>
    </v-card>
  </div>
</template>

<!--
  - Commented.by.KWShin.2026.07.15.
  - 사용자의 메뉴접근권한을 설정하는 기능을 작성하기 위해
    이 컴포넌트를 복사하여 /views/preference/user/UserMenuControl.vue 컴포너트로 복사하여 기능을 추가하였으므로
    이 수정되면 영향을 미치는 동일한 부분을 UserMenuControl.vue에서도 수정하여야 함.
-->

<script>
import { mapState, mapGetters } from 'vuex';
import { api } from '@/api/common/instances';
import bus from '@/utils/bus';
import GroupSelector from './GroupSelectorNeo.vue';
// import { el } from 'date-fns/locale';

export default {
  components: {
    GroupSelector,
  },
  data() {
    return {
      // BEGIN::Added.by.KWShin.2024.07.03.
      showMenu: false,
      // FINISH::Added.by.KWShin.2024.07.03.
      primeMenuList: [],
      ctxtMenu: {
        show: false,
        x: 0,
        y: 0,
        path: '',
        title: this.$t('menu.title.reg.home'),
      },
    };
  },
  computed: {
    ...mapState('common/user', ['username']),
    ...mapState('common/system', ['system', 'stackType']),
    ...mapState('common/menu', ['realtime', 'analstatic', 'extraordinaries', 'allowedMenuIds']),
    ...mapGetters('common/system', ['getSystemById', 'getSystemsByStack']),
    currentPath() {
      return this.$route.path;
    },
  },
  methods: {
    // BEGIN::Added.by.KWShin.2025.12.04.
    /**
     * 우클릭이 발생한 메뉴를 현재 사용자의 홈화면으로 등록하여 준다.
     * 화면 중에는 PATH VARIABLE로 systemId를 받아야만 하는 것들도 있다.
     * 시스템 선택기가 존재하는 화면이 첫화면으로 등록되는 경우에는
     * 현재 선택된 시스템의 ID를 PATH VARIABLE로 붙여서 등록한다.
     */
    registerHome() {
      this.ctxtMenu.show = false;
      const route = this.$router.options.routes.find(r => {
        return r.path.startsWith(this.ctxtMenu.path);
      });
      api.put(`/prefer/users/${this.username}/motlet-properties`, {
        motletId: `first/screen/after/login`,
        motletProperties: route.meta.hiddenGroupSelector ? this.ctxtMenu.path : `${this.ctxtMenu.path}/${this.system.id}`,
      });
    },
    /**
     * 메뉴에서 우클릭이 발생하면 해당 메뉴를 홈화면으로 설정할 수 있는 메뉴를 보여준다.
     */
    onContextMenu(e, menu) {
      e.preventDefault();
      this.ctxtMenu.x = e.clientX;
      this.ctxtMenu.y = e.clientY;
      this.ctxtMenu.path = menu.url;
      this.ctxtMenu.show = true;
    },
    // FINISH::Added.by.KWShin.2025.12.04.
    showQuickMenu(e) {
      e.stopPropagation();
      e.preventDefault();
      this.showMenu = true;
    },
    toggleQuickMenu(e) {
      e.stopPropagation();
      e.preventDefault();
      this.showMenu = !this.showMenu;
    },
    changeMenu(menu) {
      // 현재 페이지와 동일한 URL을 가진 메뉴로 이동하고자 하는 경우에는 그냥 리턴.
      if (this.$router.currentRoute.fullPath.startsWith(menu.url)) return;

      const route = this.$router.options.routes.find(r => {
        return r.path.startsWith(menu.url);
      });
      const { stackType } = this.system;
      // 선택된 메뉴가 stackType 의존적인 페이지인데 현재 시스템의 stackType과 일치하지 않을 경우
      if (stackType != route.meta.stackType && (stackType != 'DUAL' || route.meta.stackType != 'ALL')) {
        const sstmsStack = this.getSystemsByStack(route.meta.stackType);
        const sstmSwapped = sstmsStack.length > 0 ? sstmsStack[0] : this.system; // 메뉴가 해당 stacktype의 시스템이 없는 경우 표시가 안되면 여기에 걸릴 일 없음.
        this.$store.dispatch('common/system/setSystem', sstmSwapped.id);
      }
      // 시스템선택기(GroupSelector)를 보여주지 않으면 그냥 URL로 이동하고
      // 시스템선택기를 보여주는 페이지의 경우 시스템을 URL에 첨부하여 이동.
      if (route.meta.hiddenGroupSelector == true) {
        this.$router.push(menu.url);
      } else {
        this.$router.push(`${menu.url}/${this.system.id}`);
      }
    },
    removeMenu(menuList, name) {
      menuList.forEach((menu, idx, arr) => {
        if (menu.name == name) {
          arr.splice(idx, 1);
        } else {
          if (menu.children.length) this.removeMenu(menu.children, name);
        }
      });
    },
    /**
     * Added.by.KWShin.2026.07.20.
     * 트리구조로 된 메뉴 목록에서
     * idSet에 들어 있는 ID를 가진 메뉴 이외에는 제거.
     * 메뉴 목록이 children 속성을 가진 트리구조이므로 재귀적 호출을 사용.
     * /views/preference/Preference.vue에 동일한 로직이 있으므로 수정시에는 같이 수정할 것.
     */
    findAllowedMenuOnly(nodes, idSet) {
      if (!nodes || nodes.length === 0) return [];
      return nodes
        .map(node => {
          // 기존 객체가 오염되지 않도록 얕은 복사 수행
          const copiedNode = { ...node };
          // 자식 메뉴가 있다면 자식 메뉴들 먼저 재귀적으로 필터링을 진행 (하향 탐색)
          if (copiedNode.children && copiedNode.children.length > 0) {
            copiedNode.children = this.findAllowedMenuOnly(copiedNode.children, idSet);
          }
          return copiedNode;
        })
        .filter(node => {
          // [필터링 조건]
          // 내가 허용된 ID(idSet에 존재)이거나,
          // 혹은 내 자식들(children) 중 살아남은 노드가 하나라도 있다면 이 노드를 유지합니다.
          const isMyIdAllowed = idSet.has(node.id);
          const hasActiveChildren = node.children && node.children.length > 0;

          return isMyIdAllowed || hasActiveChildren;
        });
    },
  },
  created() {
    // BEGIN::Modified.by.KWShin.2026.01.06.
    // this.primeMenuList = this.realtime.concat(this.analstatic);
    this.primeMenuList = this.realtime.concat(this.analstatic, this.extraordinaries);
    // FINISH::Modified.by.KWShin.2026.01.06.

    const abapSstmCnt = this.getSystemsByStack('ABAP').length;
    const javaSstmCnt = this.getSystemsByStack('JAVA').length;
    const dualSstmCnt = this.getSystemsByStack('DUAL').length;

    if (abapSstmCnt == 0 && dualSstmCnt == 0) this.removeMenu(this.primeMenuList, 'abap');
    if (javaSstmCnt == 0 && dualSstmCnt == 0) this.removeMenu(this.primeMenuList, 'java');

    // BEGIN::Added.by.KWShin.2026.07.20.
    // 접근이 허용된 메뉴ID 목록에 없는 메뉴는 목록에서 제거한다.
    // 접근허용메뉴ID 목록이 없으면 전체 메뉴를 모두 노출한다.
    if (this.allowedMenuIds.length > 0) {
      const idSet = new Set(this.allowedMenuIds);
      this.primeMenuList = this.findAllowedMenuOnly(this.primeMenuList, idSet);
    }
    // FINISH::Added.by.KWShin.2026.07.20.

    bus.$on('toggle-main-menu', param => {
      if (param != undefined) {
        this.showMenu = param;
      } else {
        this.showMenu = !this.showMenu;
      }
    });
  },
};
</script>
<style scoped lang="scss">
// 테마와 관련된 색상 설정은 /style/common/color/scss에 정의되어 있음.2024.08.29.KWShin.
.quick-menu {
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  width: 100vw;
  z-index: 100;
  display: block;

  &.menu-selected {
    div.quick-menu-dummy {
      display: block;
    }

    div.quick-menu-wraper {
      max-height: calc(100vh - 70px);
      top: -20px;
    }
  }

  div.quick-menu-dummy {
    position: absolute;
    display: none;
    left: 0px;
    top: -38px;
    right: 0px;
    height: calc(100vh - 40px);
    z-index: 15;
  }

  div.quick-menu-wraper {
    position: absolute;
    max-height: 0px;
    overflow-x: hidden;
    overflow-y: auto;
    left: 0px;
    right: 0px;
    // top: -100px;
    z-index: 20;
    // transition: 0.5s max-height, 1s top; // transition 효과를 주면 메뉴가 덜그덕거리는 느낌이어서 제거함.2023.10.16.KWShin.
    border-radius: 0 0 10px 10px;
    padding: 0 10px;
    text-align: center;

    dl.quick-menu-sub,
    dl.quick-menu-child {
      text-align: left;
      min-width: 208px;
      display: inline-block;
      vertical-align: top;
      margin: 3px;
      > dt {
        font-size: 1.6rem;
        font-weight: bold;
        padding: 3px;
        position: relative;
        > .v-icon {
          font-size: 16px;
          margin-right: 0.3rem;
          margin-left: 1rem;
        }
        > span {
          position: relative;
          padding: 0.1rem 2rem 0.1rem 0.5rem;
        }
        > span::after {
          content: '';
          position: absolute;
          left: 0;
          right: 100%;
          bottom: 0px;
          height: 20px;
          // 원래 Box로 감싸던 것을 left/bottom border만 그리도록 수정하고 transition 효과도 0.5초로 단축함.2023.10.16.KWShin.
          // border: 1px solid transparent;
          // border-radius: 5px 20px 20px 5px;
          // transition: 1s right;
          border-left: 1px solid transparent;
          border-bottom: 1px solid transparent;
          border-radius: 0 0 0 5px;
          transition: 0.5s right;
        }
      }
      > dd {
        // padding: 0.5rem 0;
        margin: 0;
      }
      &.menu-selected,
      &:hover {
        > dt {
          &,
          > .v-icon {
            color: #f57c00;
          }
          border-bottom-style: solid;
          > span::after {
            right: 10%;
            // 원래 바탕색이 채워지던 것을 제거함.2023.10.16.KWShin.
            // background-color: rgba(var(--ow-primary-rgb), 0.2);
            border-color: #f57c00;
          }
        }
      }
    }
    dl.quick-menu-sub {
      margin: 10px 5px;
      > dd {
        margin-top: 3px;
        border: 1px solid rgba(255, 255, 255, 0.5);
        border-radius: 0 0 10px 10px;
        box-shadow: 0 3px 3px -2px rgb(100 100 100 / 20%), 0 5px 5px 0 rgb(100 100 100 / 14%), 0 1px 15px 0 rgb(100 100 100 / 12%);
      }
    }
    ul.quick-menu-grand {
      list-style: none;
      margin: 0;
      padding: 0 0 0 1rem;
      font-size: 1.2rem;
      > li {
        > a {
          display: block;
          margin: 0.1rem 0;
          text-decoration: none;
          line-height: 26px;
          > span {
            position: relative;
            display: inline-block;
            vertical-align: middle;
            padding: 0.1rem 0.7rem 0.1rem 0.7rem;
            text-underline-offset: 4px;
            max-width: 180px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            &::after {
              content: '';
              position: absolute;
              left: 0;
              right: 100%;
              bottom: 0px;
              height: 26px;
              border-left: 1px solid transparent;
              border-bottom: 1px solid transparent;
              border-radius: 0 0 0 5px;
              transition: 0.5s right;
            }
          }
          > .v-icon {
            margin-right: 0.7rem;
            margin-left: 1rem;
          }
          &.menu-selected {
            > span {
              text-decoration: underline;
            }
          }
          &.menu-selected,
          &:hover {
            &,
            > .v-icon {
              color: #f57c00;
            }
          }
          &:hover {
            > span::after {
              right: 0%;
              border-color: #f57c00;
            }
          }
        }
      }
    }
  }
}
</style>
